import {
  ROLE_OPERATION_MANAGER,
  ROLE_PRINCIPAL_INVESTIGATOR,
  ROLE_SITE_FINANCIAL_COORDINATOR,
  ROLE_STUDY_MANAGER
} from '../../../constants/userRoles';

export const fixedAndExpensesFinanceAccessRoles = [ROLE_OPERATION_MANAGER, ROLE_SITE_FINANCIAL_COORDINATOR];

export const financeDashboardsAccessRoles = [
  ROLE_OPERATION_MANAGER,
  ROLE_PRINCIPAL_INVESTIGATOR,
  ROLE_SITE_FINANCIAL_COORDINATOR,
  ROLE_STUDY_MANAGER
];

export const ON_CHANGE = {
  ON_SELECT_CHANGE: 'ON_SELECT_CHANGE',
  ON_SELECT_DATE_CHANGE: 'ON_SELECT_DATE_CHANGE',
  ON_SITE_SELECT_CHANGE: 'ON_SITE_SELECT_CHANGE',
  ON_SITE_SELECT_STUDIES: 'ON_SITE_SELECT_STUDIES',
  ON_SITE_SELECT_STUDIES_NON_FILTERED: 'ON_SITE_SELECT_STUDIES_NON_FILTERED',
  ON_STUDY_CHANGE_WITH_SITE: 'ON_STUDY_CHANGE_WITH_SITE',
  ON_STUDY_CHANGE_WITH_THERAPEUTIC_AREAS: 'ON_STUDY_CHANGE_WITH_THERAPEUTIC_AREAS',
  ON_STUDY_CHANGE_WITH_THERAPEUTIC_AREAS_FILTER_CANCELED_SSUS:
    'ON_STUDY_CHANGE_WITH_THERAPEUTIC_AREAS_FILTER_CANCELED_SSUS',
  ON_STUDY_METRICS_STUDY_CHANGE: 'ON_STUDY_METRICS_STUDY_CHANGE',
  ON_STUDY_MULTISELECT_CHANGE: 'ON_STUDY_MULTISELECT_CHANGE',
  ON_STUDY_MULTISELECT_CHANGE_FILTER_CANCELED_SSUS: 'ON_STUDY_MULTISELECT_CHANGE_FILTER_CANCELED_SSUS',
  ON_STUDY_MULTISELECT_CHANGE_NON_FILTERED: 'ON_STUDY_MULTISELECT_CHANGE_NON_FILTERED',
  ON_STUDY_SELECT_CHANGE: 'ON_STUDY_SELECT_CHANGE'
};

export const ON_INIT = {
  SET_DATA_FILTER_SITES_BY_CANCELED_SSUS: 'SET_DATA_FILTER_SITES_BY_CANCELED_SSUS',
  SET_DATA_WITH_START_AND_END_DATE_DEFAULT_1_YEAR_AGO: 'SET_DATA_WITH_START_AND_END_DATE_DEFAULT_1_YEAR_AGO',
  SET_DATA_WITH_START_AND_END_DATE_DEFAULT_3_MONTHS_AGO: 'SET_DATA_WITH_START_AND_END_DATE_DEFAULT_3_MONTHS_AGO',
  SET_DATA_WITH_START_AND_END_DATE_DEFAULT_6_MONTH_AGO: 'SET_DATA_WITH_START_AND_END_DATE_DEFAULT_6_MONTH_AGO',
  SET_DATA_WITH_START_AND_END_DATE_DEFAULT_BEGINNING_OF_CURRENT_MONTH:
    'SET_DATA_WITH_START_AND_END_DATE_DEFAULT_BEGINNING_OF_CURRENT_MONTH',
  SET_DATA_WITH_START_AND_END_DATE_DEFAULT_WEEK_AGO: 'SET_DATA_WITH_START_AND_END_DATE_DEFAULT_WEEK_AGO',
  SET_DATE_TO_EMPTY: 'SET_DATE_TO_EMPTY',
  SET_DATE_TO_NOW: 'SET_DATE_TO_NOW'
};
